import { combineReducers } from 'redux';

import { UI_TABS } from 'constants/ChatConstants';
import * as types from 'modules/chat/actionTypes';
import loading from 'modules/global/reducers/generic.loading';
import { createReducer } from 'utils/ReduxUtils';

import customerConversation from './customer';
import internalConversation from './internal';
import isInit from './isInit';

/**
 * @typedef {{
 *   isInit: boolean,
 *   patching: boolean,
 *   selectedConversation: string | null,
 *   activeTab: 'ALL_CLIENT' | 'MY_CLIENT' | 'INTERNAL',
 *   customerConversation: import("./customer").ChatUiCustomerReducer
 *   internalConversation: import("./internal").ChatUiInternalReducer,
 * }} ChatUiDashboardReducer
 */

export default combineReducers({
  isInit,
  customerConversation,
  internalConversation,
  patching: loading(types.PATCH_CONVERSATION_STATUS),
  activeTab: createReducer(UI_TABS.MY_CLIENT, {
    [types.SET_ACTIVE_TABS]: (_, { payload }) => payload,
  }),
});
